<template>
    <div>
        <a-form layout="inline" class="mb-20">
            <!-- <a-form-item label="工作人员手机号">
                <a-input v-model="dataForm.phonenumber" placeholder="手机号搜索" />
            </a-form-item> -->
            <a-form-item>
                <a-button @click="getDataList" type="">刷新数据</a-button>
            </a-form-item>
        </a-form>
        <!-- 设置每个表格的行高为100px -->
        <a-table :columns="columns" :scroll="{ x: 540 }" :data-source="dataList" :pagination="false" rowKey="id"
            :key="tableKey" :loading="dataListLoading" :row-height="200">
            <template slot="call" slot-scope="text, row">
                <div>主叫: {{ row.peer_no }}</div>
                <div>显号: {{ row.secret_no }}</div>
                <div>被叫: {{ row.phone_no }}</div>
            </template>
            <template slot="calltime" slot-scope="text, row">
                <div>发起: {{ row.call_out_time }}</div>
                <div>接通: {{ row.start_time }}</div>
                <div>挂断: {{ row.release_time }}</div>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a-tooltip v-permission="['admin:trip:playaudio']">
                    <template slot="title" v-if="row.duration == 0">
                        {{ row.duration == 0 ? '无语音文件' : row.fileok == 0 ?
                            '语音文件生成中' : '' }}
                    </template>
                    <a-space :size="20">
                        <div v-permission="['admin:trip:downloadaudio']">
                            <a type="link" :disabled="row.duration == 0 || row.fileok == 0" @click="playaudio(row)">
                                {{ row.id == play.id ? play.status == 'play' ? '停止播放' : '播放' : '播放' }}
                            </a>
                        </div>
                        <div v-permission="['admin:trip:downloadaudio']">
                            <a type="link" @click="downloadaudio(row)"
                                :disabled="getMinutesDiff(row.release_time, row.start_time) == 0 || row.fileok == 0">
                                下载
                            </a>
                        </div>
                    </a-space>
                </a-tooltip>
            </template>
        </a-table>
        <a-pagination size="small" class="mr-20 float-right" :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <audio ref="audioPlayer" controls hidden @ended="onAudioEnd"></audio>
        <div style="height: 20px;"></div>
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
export default {
    mixins: [viewModule],
    props: ['trip_id', 'customer_id', 'subsId'],
    data() {
        return {
            tableKey: new Date().getDate(),
            dataForm: {
                trip_id: this.trip_id,
                customer_id: this.customer_id,
                subsId: this.subsId,
            },
            mixinViewModuleOptions: {
                getDataListURL: "/admin/trip/calllog",
            },
            columns: [{
                title: "隐私号码",
                dataIndex: "secret_no",
                width: 140
            }, {
                title: "呼叫号码",
                scopedSlots: { customRender: "call" },
                width: 180
            }, {
                title: '呼叫时间',
                scopedSlots: { customRender: "calltime" },
                width: 220
            }, {
                title: '通话时长',
                dataIndex: "duration",
                // customRender: (text, row) => this.getMinutesDiff(row.release_time, row.start_time) + '分钟',
                fixed: 'right',
                width: 100
            }, {
                title: "操作",
                scopedSlots: { customRender: "editBtn" },
                fixed: 'right',
                width: 160,
            }],
            play: {
                id: "",
                status: ""
            }

        };
    },
    methods: {
        getMinutesDiff(a, b) {
            const startTimestamp = new Date(a).getTime();
            const endTimestamp = new Date(b).getTime();
            const diffInSeconds = Math.abs(endTimestamp - startTimestamp) / 1000; // 计算秒数
            return Math.ceil(diffInSeconds / 60); // 向上取整，确保几秒钟也算一分钟
        },
        playaudio(row) {
            if (this.play.id === row.id && this.play.status !== "pause") {
                // 如果点击的是当前音频，则暂停
                this.$refs.audioPlayer.pause();
                this.play.status = "pause"
            } else {
                this.play.id = row.id
                this.$refs.audioPlayer.src = row.record_url;
                this.$refs.audioPlayer.play();
                this.play.status = "play"
            }
        },
        onAudioEnd() {
            this.play.id = ""
            this.play.status = ""
            this.tableKey = new Date().getDate()
        },
        // 下载
        downloadaudio(row) {
            // window.open(row.record_url)
            const a = document.createElement('a');
            a.href = row.record_url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
    }
};
</script>

<style></style>